var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScuoreCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "200 150 624 724",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4963 7730 c-65 -33 -102 -68 -132 -129 -18 -35 -26 -69 -90 -366 -17 -77 -69 -318 -116 -535 -48 -217 -169 -782 -271 -1255 -203 -945 -254 -1178 -259 -1184 -2 -2 -7 10 -11 25 -3 16 -26 97 -49 179 -24 83 -94 325 -155 539 -61 214 -117 401 -125 416 -21 40 -97 106 -141 121 -32 11 -183 14 -832 14 l-794 0 -34 -37 -34 -38 0 -202 c0 -184 2 -206 20 -235 39 -65 13 -63 713 -63 l633 0 38 -132 c21 -73 62 -214 91 -313 67 -230 184 -635 325 -1129 61 -213 117 -400 124 -415 23 -43 88 -102 136 -124 63 -28 164 -34 228 -13 63 21 133 82 160 138 10 24 70 270 131 548 119 540 174 787 221 995 17 72 95 425 174 785 188 848 216 965 216 896 0 -10 58 -239 129 -509 71 -271 159 -609 196 -752 37 -143 75 -291 85 -330 10 -38 53 -200 94 -360 94 -360 90 -348 121 -401 72 -124 254 -169 386 -97 63 34 75 51 201 278 58 105 136 244 173 310 217 387 273 487 310 555 l40 75 686 5 c642 5 687 6 713 23 49 32 56 68 56 269 0 208 -8 239 -70 271 -33 16 -88 17 -835 15 l-800 -3 -54 -30 c-30 -16 -65 -44 -79 -62 -31 -37 -181 -313 -294 -538 -66 -131 -82 -156 -89 -140 -5 11 -162 634 -350 1385 -187 751 -349 1385 -360 1410 -24 55 -80 114 -134 143 -30 16 -63 22 -135 25 -90 3 -98 2 -157 -28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScuoreCard);
export default __webpack_public_path__ + "static/media/scuore-card.ef80e14b4d7d4936d2f5f24834b21c18.svg";
export { ForwardRef as ReactComponent };